import { render } from "./BalSelectInput.vue?vue&type=template&id=474f5c04&scoped=true&ts=true"
import script from "./BalSelectInput.vue?vue&type=script&lang=ts"
export * from "./BalSelectInput.vue?vue&type=script&lang=ts"

import "./BalSelectInput.vue?vue&type=style&index=0&id=474f5c04&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474f5c04"]])

export default __exports__